function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import uuid from "./uuid";
import Promise from "bluebird";
import throttle from "lodash/throttle";
import store from "../store";
import { uploadActivityFile } from "../actions";
var UploadQueue = /*#__PURE__*/ function() {
    "use strict";
    function UploadQueue() {
        _classCallCheck(this, UploadQueue);
        this._items = [];
        this._listeners = [];
        this._triggerChange = throttle(this._triggerChange);
        this._updateItem = this._updateItem.bind(this);
    }
    var _proto = UploadQueue.prototype;
    _proto.items = function items() {
        return this._items.slice();
    };
    _proto.add = function add(file) {
        var _this = this;
        if (Array.isArray(file)) {
            file.forEach(function(f) {
                return _this._pushFile(f);
            });
        } else {
            if (_instanceof(file, File)) {
                this._pushFile(file);
            }
        }
    };
    _proto.remove = function remove(id) {
        this._items = this._items.filter(function(i) {
            return i.id !== id;
        });
        this._triggerChange();
    };
    _proto.start = function start(activity) {
        var _this = this;
        return Promise.all(this._items.filter(function(i) {
            return i.status === "pending";
        }).map(function(item) {
            store.dispatch(uploadActivityFile({
                activity: activity,
                file: item.file,
                onProgress: function(evnt) {
                    return _this._updateItem(item.id, evnt.loaded / evnt.total * 100);
                }
            }));
        }));
    };
    _proto.addChangeListener = function addChangeListener(callback) {
        this._listeners.push(callback);
    };
    _proto.removeChangeListener = function removeChangeListener(callback) {
        this._listeners = this._listeners.filter(function(l) {
            return callback !== l;
        });
    };
    _proto._triggerChange = function _triggerChange() {
        this._listeners.forEach(function(l) {
            return l();
        });
    };
    _proto._pushFile = function _pushFile(file) {
        var _this = this;
        var item = {
            id: uuid(),
            name: file.name,
            file: file,
            status: "pending",
            progress: 0
        };
        this._items.push(item);
        this._triggerChange();
        if (!!window.FileReader && file.type.match("image.*")) {
            var reader = new FileReader();
            reader.onload = function(e) {
                item.path = e.target.result;
                _this._triggerChange();
            };
            reader.readAsDataURL(file);
        }
    };
    _proto._updateItem = function _updateItem(id, progress) {
        var index = this._items.map(function(i) {
            return i.id;
        }).indexOf(id);
        if (index > -1) {
            this._items[index].progress = progress;
            if (progress > 0 && progress < 100 && this._items[index] !== "inprogress") {
                this._items[index].status = "inprogress";
            } else if (progress >= 100 && this._items[index] !== "finished") {
                this._items[index].status = "finished";
            } else if (progress === 0) {
                this._items[index].status = "pending";
            }
            this._triggerChange();
        }
    };
    return UploadQueue;
}();
export default UploadQueue;
